import { Jaco } from "oc-jaco3d/arrangement/Jaco";
import { Jaco3d } from "oc-jaco3d/arrangement3d/Jaco3d";
import * as Scenes from "oc-threejs/Scenes";
import { Leerrohr } from "../arrangement/Leerrohr";
import { Cable } from "./Cable";

export class Leerrohr3d extends Jaco3d {
  CLASS_NAME = "Leerrohr3d";
  declare jaco: Leerrohr;
  cables: Cable[] = [];

  constructor(jaco: Jaco) {
    super(jaco);
  }

  update3d() {
    super.update3d();
    if (this.changed("paths")) {
      this.cables.forEach((cable) => Scenes.remove(cable));
      const material = APP.materials.create("Leerrohr");
      this.cables = this.jaco.paths.map((path) => new Cable(path, material, 0.02));
      this.cables.forEach((c) => this.add(c));
    }
  }

  clone(recursive?: boolean) {
    return new Leerrohr3d(this.jaco) as this;
  }

  getBox() {
    return this.jaco.getBox();
  }
}
